import React, { useState } from 'react';
import { PrimaryButton } from 'library';
import { AddCircleRounded } from '@mui/icons-material';
import { ITeacher } from 'models';
import EditOrCreateNewJobModal from './EditOrCreateNewJobModal';
import { ISpotlightWorker } from 'parent-portal/home/Models/DashboardData';
import { useModalsContext } from 'ModalsContext';
import { teacherToSpotlightWorkerApiObject } from './inviteUtils';

export default function InviteButton({
    selectedWorkers,
    setSelectedWorkers,
}: {
    selectedWorkers: ITeacher[];
    setSelectedWorkers: (selectedWorkers: ITeacher[]) => void;
}) {
    const [inviteModalOpen, setInviteModalOpen] = useState(false);
    const { openJobForm } = useModalsContext();

    function handleInviteClick() {
        setInviteModalOpen(true);
    }

    function request() {
        const normalizedWorkers: ISpotlightWorker[] = selectedWorkers.map(teacherToSpotlightWorkerApiObject);

        setSelectedWorkers([]);

        openJobForm('Teacher Showcase', {
            selectedSpotlightWorkers: normalizedWorkers,
            allSpotlightWorkers: normalizedWorkers,
        });
    }

    function closeAndReset() {
        setInviteModalOpen(false);
        setSelectedWorkers([]);
    }

    return (
        <>
            <PrimaryButton
                onClick={handleInviteClick}
                buttonStyle={{
                    width: 'auto',
                    padding: 0,
                }}
                boldText={false}
                textStyle={{
                    padding: '6px 12px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
                disabled={selectedWorkers.length === 0}
            >
                <AddCircleRounded style={{ fontSize: 20, marginRight: 10 }} />
                Invite Selected Teachers
            </PrimaryButton>
            <EditOrCreateNewJobModal
                open={inviteModalOpen}
                onClose={closeAndReset}
                selectedWorkers={selectedWorkers}
                openJobForm={request}
            />
        </>
    );
}
